import axios from 'axios/index';
import store from '../store/store';
import { Message, Loading } from 'element-ui';

const env = process.env.NODE_ENV;
const imagePrefixUrl = env === 'development' ? 'http://123.249.36.247:8005/' : 'http://123.249.36.247:8005/'; //图片显示地址
const ajaxUrl = env === 'development' ? 'http://123.249.36.247:8005/' : 'http://123.249.36.247:8005/';

const nameSpace = 'api/cms/';

const ajax = axios.create({
  baseURL: `${ajaxUrl}${nameSpace}`,
  timeout: 5000,
});

let $vm = null;

let loadingInstance = null;
function startLoading () {
  loadingInstance = Loading.service({
    fullscreen: true,
    text: '加载中...',
    background: 'rgba(0, 0, 0, 0.4)'
  })
}
function endLoading () {
  loadingInstance.close()
}
let needLoadingRequestCount = 0;
function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}
function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

ajax.interceptors.request.use((req) => {
  showFullScreenLoading();
  if (!!req.url.indexOf('/login')) {
    if(store.state.token){
      req.headers.Authorization = store.state.token;
    }
  }
  return req;
}, err => {
  tryHideFullScreenLoading();
  Message.error({message: '请求超时!'});
  return Promise.reject(err)
});
ajax.interceptors.response.use(
  response => {
    tryHideFullScreenLoading();
    if (!response.data) {
      return Promise.reject('请求失败');
    }
    const { code } = response.data;
    if (code === 403) {
      const { msg } = response.data;
      const message = msg || '请求失败';
      $vm.$store.dispatch('logout');
      $vm.$message.warning(msg);
      return Promise.reject(message);
    }
    return response.data;
  },
  error => {
    tryHideFullScreenLoading();
    const { message } = error;
    if (!!message) {
      if (message.indexOf('timeout') !== -1) {
        return Promise.reject('请求超时');
      } else if (message.indexOf('Network Error') !== -1) {
        return Promise.reject('网络异常');
      } else if ($vm && message.indexOf('403') !== -1) {
        $vm.$router.push('error-403');
      } else if ($vm && message.indexOf('401') !== -1) {
        $vm.$router.push('error-401');
      } else if ($vm && message.indexOf('500') !== -1) {
        console.log('error-500');
      }
    }
    return Promise.reject('服务异常');
  },
);

const req = async (option, vm) => {
  $vm = vm;
  try {
    let res = null;
    switch (option.method) {
      case 'get':
        res = await ajax.get(option.url, { params: option.params });
        break;
      case 'delete':
        res = await ajax.delete(option.url, { data: option.data });
        break;
      default :
        res = await ajax[option.method](option.url, option.params);
    }
    option.success.call(vm, res);
  } catch (e) {
    if (option.fail) {
      option.fail.call(vm, e);
    } else {
      // vm.$message.error({
      //   content: e,
      // });
      console.log(e)
    }
  } finally {
    if (option.finally) {
      option.finally.call(vm);
    }
  }
};

const methods = ['Get', 'Post', 'Patch', 'Delete'];

const ajaxMethods = {};
methods.forEach(method => {
  ajaxMethods[`ajax${method}`] = (option, vm) => {
    const op = Object.assign(option,
      { method: method.toLowerCase() });
    req(op, vm);
  };
});

const ajaxGet = ajaxMethods.ajaxGet;
const ajaxPost = ajaxMethods.ajaxPost;
const ajaxPatch = ajaxMethods.ajaxPatch;
const ajaxDelete = ajaxMethods.ajaxDelete;

export {
  ajax,
  ajaxGet,
  ajaxPost,
  ajaxPatch,
  ajaxDelete,
  ajaxUrl,
  imagePrefixUrl,
};



// WEBPACK FOOTER //
// ./src/utils/ajax.js